<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter2">
<h2 class="chapterhead">Foreword </h2>
<p class="no_indent">Dear Reader, </p>
<p class="no_indent">I beg your indulgence as I send a long overdue valentine to Geri Jewell: </p>
<p class="indent">Geri, who’d have thought our connection would be so profound? When we met more than 30 years ago, all we had in common was our fear of performing live on Norman Lear’s television special, <em>I Love Liberty</em>. We were good celebrities inviting our fellow citizens to fully participate in our beloved democracy. As is our way, we cheered each other on. </p>
<p class="indent">How could we ever have guessed that in the ensuing years, we’d be living damn near parallel lives? Besides striving to keep our careers afloat, we’ve shadow boxed with our respective disabilities, your cerebral palsy and my bi-polar disorder. We’re a pair, all right. In reading <em>I’m Walking as Straight as I Can</em>, I couldn’t help but shake my head again and again as I came to know how many demons we had in common and above all, that any other human being could rival me in the insecurity department. Oh my dear! </p>
<p class="indent">But let me not dwell on painful histories, for we don’t live there anymore. Let us, together, invite your readers to share in the bounty borne of endurance and cock-eyed optimism. Your willingness — indeed, your eagerness — to share your road “less traveled,” demonstrates the generosity of your spirit, your sense of humor, that is just irreverent and divine. The following pages of this book are less about disability and more about learning to identify and accept the good fortune that is yours. </p>
<p class="indent">Congratulations, dear friend. Thank you for the insights and, of course, for the healing laughter you bring to your fellow travelers.  </p>
<p class="indent">Thank you, too, dear Reader. Enjoy! </p>
<p class="indent">— Anna Patty Duke </p>
</div>
<div class="footnote" id="chapter2_footnotes">
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?6a641350